import { useInfiniteQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { PageHeader } from "@/components/PageHeader";
import { CompanyHeader } from "@/features/companies/CompanyHeader";
import { Contacts } from "@/features/companies/Contacts";
import { Timeline } from "@/features/companies/Timeline";
import { get } from "@/lib/api";
import type { CompanyDetail } from "@/lib/types";

const PAGE = 50;

export function Firma() {
  const id = Number(useParams().id);
  const q = useInfiniteQuery({
    queryKey: ["company", id],
    queryFn: ({ pageParam }) => get<CompanyDetail>(`/api/companies/${id}?offset=${pageParam}&limit=${PAGE}`),
    initialPageParam: 0,
    getNextPageParam: (last, all) => (last.timeline.hasMore ? all.length * PAGE : undefined),
    enabled: Number.isInteger(id) && id > 0,
  });
  const c = q.data?.pages[0];
  const items = q.data?.pages.flatMap((p) => p.timeline.items) ?? [];

  if (q.isError) return <p className="text-sm text-destructive">{q.error.message}</p>;
  if (!c) return <div className="h-40 animate-pulse rounded-xl bg-muted motion-reduce:animate-none" />;
  return (
    <div className="space-y-8">
      <PageHeader title={c.name} parent={{ to: "/firmen", label: "Firmen" }} />
      <CompanyHeader c={c} />
      <div className="grid gap-8 lg:grid-cols-[2fr_3fr]">
        <Contacts companyId={c.id} contacts={c.contacts} />
        <Timeline companyId={c.id} contacts={c.contacts} items={items}
          hasMore={q.hasNextPage} loadingMore={q.isFetchingNextPage} onMore={() => q.fetchNextPage()} />
      </div>
    </div>
  );
}
